import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectors as userSelectors } from 'services/user';
import { selectors as authSelectors } from 'services/auth';
import { setSentryUser } from 'lib/sentry';

export const useSentryUser = () => {
  const user = useSelector(userSelectors.getUser);
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  useEffect(() => {
    if (isAuthenticated && user?.id) {
      setSentryUser({
        id: user.id,
      });
    } else {
      setSentryUser(null);
    }
  }, [user, isAuthenticated]);
};
